export const modalOpened = state => !!state.globalModal.show;
